<div class="flex flex-col gap-[18px] basic-app-tab">
   <span class="text-base text-app-primary-1">{{ 'project_editor_title' | translate }}</span>

   @if ($app.core.isProposalProject() || $app.core.isNotGrantedProject()) {
      <ep-proposal
         [project]="project$ | async"
         (hasUnsavedChanges)="hasUnsavedChanges = $event"
         (updateProjectDetailClick)="doActionUpdateProject($event)"
      ></ep-proposal>
   }

   @if ($app.core.isRunningProject() || $app.core.isEndedProject()) {
      <ep-running
         [project]="project$ | async"
         [logo]="projectLogoUrl"
         [tabIndex]="tabIndexFromUrl"
         [isLoadingLogo]="isLoadingLogo$ | async"
         [reportingPeriodsRes]="reportingPeriodsRes$ | async"
         [isLoadingReportingPeriods]="isLoadingReportingPeriods$ | async"
         (addReportClick)="doActionAddReport($event)"
         (doActionDeleteLogo)="doActionDeleteLogo()"
         (deleteReportClick)="doActionDeleteReport()"
         (doActionSaveLogo)="doActionSaveLogo($event)"
         (hasUnsavedChanges)="hasUnsavedChanges = $event"
         (updateProjectDetailClick)="doActionUpdateProject($event)"
      ></ep-running>
   }
</div>

<app-basic-confirm-dialog></app-basic-confirm-dialog>
